import './styles/main.css'
import { Login } from './pages/login/index.js'

// Initialize login page
Login.render()
